import { render, staticRenderFns } from "./RefractiveDiscrepancyUserEdit.vue?vue&type=template&id=0ae87461&scoped=true&"
import script from "./RefractiveDiscrepancyUserEdit.vue?vue&type=script&lang=js&"
export * from "./RefractiveDiscrepancyUserEdit.vue?vue&type=script&lang=js&"
import style0 from "./RefractiveDiscrepancyUserEdit.vue?vue&type=style&index=0&id=0ae87461&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae87461",
  null
  
)

export default component.exports